import React, { Suspense } from 'react';
import HomeHeroContainer from './HomeHeroContainer';
import { useSelector } from 'react-redux';
import HomeHeroContentPublic from './HomeHeroContentPublic';
import { selectIsAuthenticated } from '@/store/selectors/authSelectors';
import { selectLocale } from '@/store/selectors/commonSelectors';
import LoadingSpinner from '@/components/shared/spinner/LoadingSpinner';
import HomeHeroContentPrivateThailand from '@/pages/home/hero/thailand/HomeHeroContentPrivateThailand';
import HomeHeroContentPublicThailand from '@/pages/home/hero/thailand/HomeHeroContentPublicThailand';

const HomeHeroContentPrivate = React.lazy(() => import('./HomeHeroContentPrivate'));

const HomeHero = (): JSX.Element => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const locale = useSelector(selectLocale);

  return (
    <HomeHeroContainer isAuthenticated={isAuthenticated}>
      {!isAuthenticated && (
        <Suspense fallback={<LoadingSpinner />}>
          {locale === 'th' && <HomeHeroContentPublicThailand />}
          {locale !== 'th' && <HomeHeroContentPublic locale={locale} />}
        </Suspense>
      )}
      {isAuthenticated && (
        <Suspense fallback={<LoadingSpinner />}>
          {locale === 'th' && <HomeHeroContentPrivateThailand />}
          {locale !== 'th' && <HomeHeroContentPrivate />}
        </Suspense>
      )}
    </HomeHeroContainer>
  );
};

export default HomeHero;
